import React from 'react';

import { SVGIcon } from 'UIKit/index';
import Reputation from 'Assets/images/Reputation.svg';

const backgroundStyle = {
    backgroundImage: 'url(' + Reputation + ')',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
};
export default function DCReputation(props) {
    return <SVGIcon {...props} viewBox="0 0 2000 2000" style={backgroundStyle} />;
}
